import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'motion/react';
import { useQR } from '../../utils/hooks/useQR';
import { useAuth } from '../../utils/Auth';
import { useBack } from '../../utils/hooks/useBack';
import QrChildren from '../../components/QrComponents/QrChildren';
import styles from '../QrDetails/QrDetails.module.css';

export default function QrLinked(props) {
  const { reference } = props;
  const params = useParams();
  useQR(reference, params?.id || '');

  const { qr_data } = useAuth();
  const nickname = useMemo(() => qr_data?.data?.nickname || '', [qr_data?.data?.nickname]);
  const goBack = useBack();

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <AnimatePresence mode='wait'>
          <motion.div
            key='linked'
            className={styles.details}
            transition={{ duration: 0.5, ease: 'easeOut' }}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
          >
            <div className={styles.header}>
              <button
                className={styles.backBtn}
                onClick={goBack}
                style={window.location.pathname.includes('setup') ? { display: 'none' } : null}
              >
                <i className='fas fa-arrow-left' style={{ pointerEvents: 'none' }} />
                Back
              </button>
              <h4 className={styles.nickname}>{nickname}</h4>
              <div className={styles.qrId}>ID: <span>{qr_data?.id}</span></div>
            </div>
            <div className={styles.detailsInner}>
              <AnimatePresence mode='wait'>
                <motion.div
                  key='linked-list'
                  className={styles.motionWrap}
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -8 }}
                  transition={{ duration: 0.25 }}
                >
                  <QrChildren />
                </motion.div>
              </AnimatePresence>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
